module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Gabriela Muttoni - Terapeuta Integrativa","short_name":"Gabriela Muttoni","start_url":"/","background_color":"#9f7aea","theme_color":"#9f7aea","display":"minimal-ui","icon":"src/images/gabriela-logo.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"d11ea877dc393c133940ba66642edea5"},
    },{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://gabrielamuttoni.com.br","stripQueryString":true},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
